import { CANAL, APP_VERSION } from "../helpers/constants";
import { axiosInstance } from "../helpers/axios";

const userAgent = window.navigator.userAgent;

const getAnios = (user, id, securitykey) => {
  return axiosInstance
    .post("getModelosv2/", {
      usuario: user,
      canal: CANAL,
      version: APP_VERSION,
      ID: id,
      llaveSeguridad: securitykey,
    })
    .then((res) => {
      const data = res.data;
      return data;
    })
    .catch((err) => {
      console.log("error");
      console.log(err.message);
      return Promise.reject(err);
    });
};

const getSucursales = (usuario, securitykey, latitud, longitud) => {
  return axiosInstance
    .post("getSucursales/", {
      canal: CANAL,
      carrierCelular: userAgent,
      codigoPostal: "",
      ID: "",
      ip_dispositivo: "0.0.0.0",
      latitude: latitud,
      llaveSeguridad: securitykey,
      longitude: longitud,
      modelo: "",
      userAgent: userAgent,
      usuario: usuario,
      version: APP_VERSION,
    })
    .then((res) => {
      const data = res.data;
      return data;
    })
    .catch((err) => {
      console.log("error");
      console.log(err.message);
      return Promise.reject(err);
    });
};

export default { getAnios, getSucursales };
